import { render } from "./footer-view.vue?vue&type=template&id=44ef248c&scoped=true"
import script from "./footer-view.vue?vue&type=script&lang=js"
export * from "./footer-view.vue?vue&type=script&lang=js"

import "./footer-view.vue?vue&type=style&index=0&id=44ef248c&lang=scss&scoped=true"

import exportComponent from "D:\\Desktop\\haorun-website-pc-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ef248c"]])

export default __exports__